import styled from 'styled-components/macro';
import { Tooltip as ReactTooltip } from 'react-tooltip';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 6px;
  height: fit-content;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const LoaderWrapper = styled.div`
  padding-top: 6px;
`;

export const StyledReactTooltip = styled(ReactTooltip)`
  z-index: 9999;
  padding: 12px !important;
  background: #354153 !important;
  border-radius: 8px !important;
  max-width: 304px;
  text-align: center;
`;
